import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import { Modal, Button, Form, Tabs, Tab, Col, Row } from "react-bootstrap";
import { FaDownload, FaEdit, FaEye, FaFileExcel, FaTrash } from "react-icons/fa";
import axios from "axios";
import Swal from "sweetalert2";


// const API_URL = "http://localhost:8000/doc_pxy.php";

const API_URL = "https://crm.fazoacademy.in/php/doc_pxy.php";




const today = new Date().toISOString().split('T')[0];

function Jobassist({ onLogout }) {
    const [courses, setCourses] = useState([]);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectjob, setSelectJob] = useState(null);


    // edit 
    const [showEditModal, setShowEditModal] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);


    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        option: "",
        total_amount: "",
        joining_date: "",
        firstpayment: "",
        // first_date: "",
        secoundpayment: "",
        // secound_date: "",
        thirdpayment: "",
        // third_date: "",
        process_level: "",
        notes: "",
        balance_amount: "",
        paymentstatus: ""

    })

    const [edit, setEdit] = useState({
        id: null,
        name: "",
        email: "",
        phone: "",
        option: "",
        total_amount: "",
        joining_date: "",
        firstpayment: "",
        secoundpayment: "",
        // secound_date: "",
        thirdpayment: "",
        // third_date: "",
        process_level: "",
        notes: "",
        balance_amount: "",
        paymentstatus: ""
    })

    const [searchQuery, setSearchQuery] = useState("");







    useEffect(() => {
        fetchCourses();
        // fetchStudent();
    }, []);



    const fetchCourses = async () => {
        try {
            const response = await axios.get(API_URL);
            const jsonString = response.data.substring(response.data.indexOf("["));
            const parsedData = JSON.parse(jsonString);
            setCourses(Array.isArray(parsedData) ? parsedData : []);
        } catch (error) {
            console.error("Error fetching courses:", error);
            setCourses([]);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prevData) => {
            const updatedData = {
                ...prevData,
                [name]: value
            };

            // Parse values
            const first = parseFloat(updatedData.firstpayment) || 0;
            const second = parseFloat(updatedData.secoundpayment) || 0;
            const third = parseFloat(updatedData.thirdpayment) || 0;
            const total = parseFloat(updatedData.total_amount) || 0;

            // Calculate total paid and balance
            const totalPaid = first + second + third;
            const balance = total - totalPaid;

            updatedData.balance_amount = balance.toFixed(2);

            // Auto-set payment status
            updatedData.paymentstatus = balance <= 0 ? "Paid" : "Partially Paid";

            return updatedData;
        });
    };

    const first1 = parseFloat(edit.firstpayment) || 0;
    const second2 = parseFloat(edit.secoundpayment) || 0;
    const third3 = parseFloat(edit.thirdpayment) || 0;
    const total1 = parseFloat(edit.total_amount) || 0;

    // Calculate total paid and balance
    const totalPaid = first1 + second2 + third3;
    const balance1 = total1 - totalPaid;

    edit.balance_amount = balance1.toFixed(2);

    // Auto-set payment status
    edit.paymentstatus = balance1 <= 0 ? "Paid" : "Partially Paid";


    const handleAddCourse = async () => {
        const trimmedName = formData.name.trim();
        const trimmedEmail = formData.email.trim();
        const trimmedPhone = formData.phone.trim();
        const trimmedOption = formData.option.trim();
        const trimmedTotal = formData.total_amount.trim();
        const trimmedJoining = formData.joining_date.trim();
        const trimmedFirstPayment = formData.firstpayment.trim();
        // const trimmedFirstDate = formData.first_date.trim();
        const trimmedSecondPayment = formData.secoundpayment.trim();
        // const trimmedSecondDate = formData.secound_date.trim();
        const trimmedThirdPayment = formData.thirdpayment.trim();
        // const trimmedThirdDate = formData.third_date.trim();
        const trimmedProcess = formData.process_level.trim();
        const trimmedNotes = formData.notes.trim();
        const trimmedbalance = formData.balance_amount.trim();
        const trimmedpaymentstatus = formData.paymentstatus.trim();

        if (
            !trimmedName || !trimmedEmail || !trimmedPhone || !trimmedOption ||
            !trimmedTotal || !trimmedJoining || !trimmedFirstPayment ||
           !trimmedProcess
        ) {
            Swal.fire({
                icon: "warning",
                title: "Missing Fields",
                text: "Please fill all required fields",
            });
            return;
        }

        if (courses.some(course => course.phone === trimmedPhone)) {
            Swal.fire({
                icon: "error",
                title: "Duplicate Phone",
                text: "This phone number is already registered!",
            });
            return;
        }
        console.log(formData)

        try {
            await axios.post(API_URL, {
                name: trimmedName,
                email: trimmedEmail,
                phone: trimmedPhone,
                option: trimmedOption,
                total_amount: trimmedTotal,
                joining_date: trimmedJoining,
                firstpayment: trimmedFirstPayment,
                // first_date: trimmedFirstDate,
                secoundpayment: trimmedSecondPayment,
                // secound_date: trimmedSecondDate,
                thirdpayment: trimmedThirdPayment,
                // third_date: trimmedThirdDate,
                process_level: trimmedProcess,
                notes: trimmedNotes,
                paymentstatus: trimmedpaymentstatus,
                balance_amount: trimmedbalance
            });

            fetchCourses();
            setFormData({
                name: "",
                email: "",
                phone: "",
                option: "",
                total_amount: "",
                joining_date: "",
                firstpayment: "",
                // first_date: "",
                secoundpayment: "",
                // secound_date: "",
                thirdpayment: "",
                // third_date: "",
                process_level: "",
                notes: "",
                balance_amount: "",
                paymentstatus: ""
            });
            setShowAddModal(false);
            Swal.fire({
                icon: "success",
                title: "Success!",
                text: " Details added successfully!",
                showConfirmButton: false,
                timer: 2000,
            });
        } catch (error) {
            console.error("Error adding course:", error);
            Swal.fire({
                icon: "error",
                title: "Oops!",
                text: "Failed to add  details.",
            });
        }
    };

    const handleEditCourse = async () => {
        const trimmedName = edit.name.trim();
        const trimmedEmail = edit.email.trim();
        const trimmedPhone = edit.phone.trim();
        const trimmedOption = edit.option.trim();
        const trimmedTotalAmount = edit.total_amount.trim();
        const trimmedJoiningDate = edit.joining_date.trim();
        const trimmedFirstPayment = edit.firstpayment.trim();
        const trimmedSecondPayment = edit.secoundpayment.trim();
        const trimmedThirdPayment = edit.thirdpayment.trim();
        const trimmedProcessLevel = edit.process_level.trim();
        const trimmedNotes = edit.notes.trim();
        const trimmedbalance = edit.balance_amount.trim();
        const trimmedpaymentstatus = edit.paymentstatus.trim();

        if (
            !trimmedName ||
            !trimmedEmail ||
            !trimmedPhone ||
            !trimmedOption ||
            !trimmedTotalAmount ||
            !trimmedJoiningDate ||
            !trimmedFirstPayment ||
            !trimmedSecondPayment ||
            !trimmedThirdPayment ||
            !trimmedProcessLevel ||
            !trimmedNotes ||
            !trimmedbalance ||
            !trimmedpaymentstatus
        ) {
            Swal.fire({
                icon: "warning",
                title: "Field EMPTY",
                text: "Please fill all the fields",
            });
            return;
        }



        try {
            await axios.put(`${API_URL}`, {
                id: edit.id,
                name: trimmedName,
                email: trimmedEmail,
                phone: trimmedPhone,
                option: trimmedOption,
                total_amount: trimmedTotalAmount,
                joining_date: trimmedJoiningDate,
                firstpayment: trimmedFirstPayment,
                secoundpayment: trimmedSecondPayment,
                thirdpayment: trimmedThirdPayment,
                process_level: trimmedProcessLevel,
                notes: trimmedNotes,
                balance_amount: trimmedbalance,
                paymentstatus: trimmedpaymentstatus
            });

            fetchCourses();
            setShowEditModal(false);
            Swal.fire({
                icon: "success",
                title: "Updated!",
                text: "Details updated successfully!",
                showConfirmButton: false,
                timer: 2000,
            });
        } catch (error) {
            console.error("Error updating  details:", error);
            Swal.fire({
                icon: "error",
                title: "Oops!",
                text: "Failed to update  details.",
            });
        }
    };

    const handleDeleteCourse = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios.delete(`${API_URL}?id=${id}`);
                    fetchCourses();
                    Swal.fire("Deleted!", "Details deleted successfully.", "success");
                } catch (error) {
                    console.error("Delete error:", error);
                    Swal.fire("Error", "Failed to delete", "error");
                }
            }
        });
    };



    const handleViewDetail = (courses) => {
        setShowViewModal(true);
        setSelectJob(courses)

    }


    const handleExportToExcel = () => {
        window.open(`${API_URL}?export=excel`, "_blank");
    };

    const filteredCourses = courses.filter((course) =>
        course.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        course.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
        course.phone.toLowerCase().includes(searchQuery.toLowerCase()) ||
        course.paymentstatus.toLowerCase().includes(searchQuery.toLowerCase()) ||
        course.process_level.toLowerCase().includes(searchQuery.toLowerCase())


    );


    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentCourses = filteredCourses.slice(indexOfFirstItem, indexOfLastItem);

    return (
        <div className="course-container">
            <div className="navigation">
                <a href="#">Job Assist</a> / <a href="#" onClick={onLogout}>Logout</a>
            </div>

            <div className="add-course">
                <button onClick={() => setShowAddModal(true)} className="add-btn">Add new details +</button>
            </div>

            <div className="d-flex justify-content-between">


                {/* Items per page selection */}
                <Form.Select
                    value={itemsPerPage}
                    onChange={(e) => setItemsPerPage(Number(e.target.value))}
                    className="pagination-select"
                >
                    <option value="10">Show 10</option>
                    <option value="20">Show 20</option>
                    <option value="30">Show 30</option>
                </Form.Select>

                <div className="search-container">
                    <Form.Control
                        type="text"
                        placeholder="Search "
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="search-input"
                    />
                </div>

                <Button onClick={handleExportToExcel} className="excel-btn">
                    <FaFileExcel className="excel-icon" /> Export to Excel
                </Button>

            </div>
            <Table striped bordered hover className="course-table">
                <thead>
                    <tr>
                        <th>S.No</th>
                        <th> Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Course</th>
                        <th>Amount</th>
                        <th>Join Date</th>
                        <th>Process Level</th>
                        <th>Notes</th>

                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {currentCourses.length === 0 ? (
                        <tr>
                            <td colSpan="10" className="text-center text-danger">
                                No details found
                            </td>
                        </tr>
                    ) : (
                        currentCourses.map((course, index) => (
                            <tr
                                key={course.id}
                                className={course.status === "Active" ? "table-success" : "table-danger"}
                            >
                                <td>{indexOfFirstItem + index + 1}</td>
                                <td>{course.name}</td>
                                <td>{course.email}</td>
                                <td>{course.phone}</td>
                                <td>{course.option}</td>
                                <td>{course.total_amount}</td>
                                <td>{course.joining_date}</td>
                                <td>{course.process_level}</td>
                                <td>{course.notes}</td>


                                <td>
                                    {course.status === "Active" && (
                                        <>

                                            <FaEdit
                                                className="edit-icon"
                                                onClick={() => {
                                                    setEdit(course);
                                                    setShowEditModal(true);
                                                }}
                                            />
                                            <FaTrash
                                                className="delete-icon"
                                                onClick={() => handleDeleteCourse(course.id)}
                                            /> &nbsp;

                                            <FaEye className="view-icon"
                                                onClick={() => handleViewDetail(course)}
                                            />
                                        </>

                                    )}
                                </td>

                            </tr>
                        )))}
                </tbody>

            </Table>

            {/* Pagination Controls */}
            <div className="pagination-controls">
                <Button variant="secondary" onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))} disabled={currentPage === 1}>
                    Previous
                </Button>
                <span className="page-number">Page {currentPage}</span>
                <Button
                    variant="secondary"
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    disabled={indexOfLastItem >= filteredCourses.length}
                >
                    Next
                </Button>
            </div>

            {/* Add Mentor Modal */}
            <Modal show={showAddModal} onHide={() => setShowAddModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Add  Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Name</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder="Enter name"
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Email</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="Enter email"
                                />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Phone</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    type="text"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={(e) => {
                                        const input = e.target.value;
                                        if (/^\d{0,10}$/.test(input)) {
                                            handleChange({ target: { name: 'phone', value: input } });
                                        }
                                    }}
                                    placeholder="Enter Mobile Number"
                                />
                                {formData.phone.length > 0 && formData.phone.length !== 10 && (
                                    <div style={{ color: 'red', marginTop: '5px' }}>
                                        Enter Valid Phone Number.
                                    </div>
                                )}
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Option</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    as="select"
                                    name="option"
                                    value={formData.option}
                                    onChange={handleChange}
                                >
                                    <option value="">Select Option</option>
                                    <option value="ALL" >ALL</option>
                                    <option value="PXY">PXY</option>
                                    <option value="DOC">DOC</option>
                                    <option value="IVS">IVS</option>
                                    <option value="DOC-IVF">DOC-IVF</option>

                                </Form.Control>
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Total Amount</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    type="text"
                                    name="total_amount"
                                    value={formData.total_amount}
                                    onChange={handleChange}
                                    placeholder="Enter total amount"
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Joining Date</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    type="date"
                                    name="joining_date"
                                    value={formData.joining_date}
                                    onChange={handleChange}
                                />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Initial Payment</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    type="text"
                                    name="firstpayment"
                                    value={formData.firstpayment}
                                    onChange={handleChange}
                                    placeholder="Enter First Payment"
                                />
                            </Col>
                        </Form.Group>

                        {/* 
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>First Date</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    type="date"
                                    name="first_date"
                                    value={formData.first_date}
                                    onChange={handleChange}
                                />
                            </Col>
                        </Form.Group> */}
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>1<sup>st</sup> Payment</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    type="text"
                                    name="secoundpayment"
                                    value={formData.secoundpayment}
                                    onChange={handleChange}
                                    placeholder="Enter Second Payment"
                                />
                            </Col>
                        </Form.Group>
                        {/* <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Second Date</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    type="date"
                                    name="secound_date"
                                    value={formData.secound_date}
                                    onChange={handleChange}
                                />
                            </Col>
                        </Form.Group> */}
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>2<sup>nd</sup> Payment</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    type="text"
                                    name="thirdpayment"
                                    value={formData.thirdpayment}
                                    onChange={handleChange}
                                    placeholder="Enter Third Payment"
                                />
                            </Col>
                        </Form.Group>
                        {/* <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Third Date</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    type="date"
                                    name="third_date"
                                    value={formData.third_date}
                                    onChange={handleChange}
                                />
                            </Col>
                        </Form.Group> */}
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Balance Amount</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    type="text"
                                    name="balance_amount"
                                    value={formData.balance_amount}
                                    onChange={handleChange}
                                    readOnly
                                    placeholder="Enter Third Payment"
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Payment Status</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    type="text"
                                    name="process_level"
                                    value={formData.paymentstatus}
                                    readOnly
                                    placeholder="Auto-detected"
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Process Level</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    type="text"
                                    name="process_level"
                                    value={formData.process_level}
                                    onChange={handleChange}
                                    placeholder="Enter Process Level"
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Notes</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    as="textarea"
                                    name="notes"
                                    value={formData.notes}
                                    onChange={handleChange}
                                    placeholder="Additional notes..."
                                    rows={3}
                                />
                            </Col>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowAddModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="success" onClick={handleAddCourse}>
                        Add Details
                    </Button>
                </Modal.Footer>
            </Modal>



            <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Name</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    value={edit.name}
                                    onChange={(e) => setEdit({ ...edit, name: e.target.value })}
                                    placeholder="Enter name"
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Email</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    type="email"
                                    name="email"
                                    value={edit.email}
                                    onChange={(e) => setEdit({ ...edit, email: e.target.value })}
                                    placeholder="Enter email"
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Phone</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    type="text"
                                    name="phone"
                                    value={edit.phone}
                                    onChange={(e) => {
                                        const input = e.target.value;
                                        if (/^\d{0,10}$/.test(input)) {
                                            setEdit({ ...edit, phone: input });
                                        }
                                    }}
                                    placeholder="Enter Mobile Number"
                                />
                                {edit.phone.length > 0 && edit.phone.length !== 10 && (
                                    <div style={{ color: 'red', marginTop: '5px' }}>
                                        Enter Valid Phone Number.
                                    </div>
                                )}
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Option</Form.Label>
                            <Col sm={9}>
                                <Form.Select
                                    name="option"
                                    value={edit.option}
                                    onChange={(e) => setEdit({ ...edit, option: e.target.value })}
                                >
                                    <option value="">-- Select Option --</option>
                                    <option value="ALL">ALL</option>
                                    <option value="PXY">PXY</option>
                                    <option value="DOC">DOC</option>
                                    <option value="IVS">IVS</option>
                                    <option value="DOC-IVF">DOC-IVF</option>
                                </Form.Select>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Joining Date</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    type="date"
                                    name="joining_date"
                                    value={edit.joining_date}
                                    onChange={(e) => setEdit({ ...edit, joining_date: e.target.value })}
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Total Amount</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    type="text"
                                    name="total_amount"
                                    value={edit.total_amount}
                                    onChange={(e) => {
                                        const input = e.target.value;
                                        if (/^\d{0,6}$/.test(input)) {
                                            setEdit({ ...edit, total_amount: input });
                                        }
                                    }}
                                    placeholder="Enter total amount"
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Initial Payment</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    type="text"
                                    name="firstpayment"
                                    value={edit.firstpayment}
                                    onChange={(e) => {
                                        const input = e.target.value;
                                        if (/^\d{0,6}(\.\d{0,2})?$/.test(input)) {
                                            setEdit({ ...edit, firstpayment: input });
                                        }
                                    }}
                                    placeholder="0.00"
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>1<sup>st</sup> Payment</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    type="text"
                                    name="secoundpayment"
                                    value={edit.secoundpayment}
                                    onChange={(e) => {
                                        const input = e.target.value;
                                        if (/^\d{0,6}(\.\d{0,2})?$/.test(input)) {
                                            setEdit({ ...edit, secoundpayment: input });
                                        }
                                    }}
                                    placeholder="0.00"
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>2<sup>nd</sup> Payment</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    type="text"
                                    name="thirdpayment"
                                    value={edit.thirdpayment}
                                    onChange={(e) => {
                                        const input = e.target.value;
                                        if (/^\d{0,6}(\.\d{0,2})?$/.test(input)) {
                                            setEdit({ ...edit, thirdpayment: input });
                                        }
                                    }}
                                    placeholder="0.00"
                                />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Balance Amt</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    type="text"
                                    name="balance_amount"
                                    value={edit.balance_amount}
                                    onChange={(e) => {
                                        const input = e.target.value;
                                        if (/^\d{0,6}(\.\d{0,2})?$/.test(input)) {
                                            setEdit({ ...edit, balance_amount: input });
                                        }
                                    }}
                                    placeholder="0.00"
                                />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Payment Status</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    type="text"
                                    name="process_level"
                                    value={edit.paymentstatus}
                                    readOnly
                                    placeholder="Auto-detected"
                                />
                            </Col>
                        </Form.Group>                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Process Level</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    type="text"
                                    name="process_level"
                                    value={edit.process_level}
                                    onChange={(e) => setEdit({ ...edit, process_level: e.target.value })}
                                    placeholder="Enter Process Level"
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Notes</Form.Label>
                            <Col sm={9}>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    name="notes"
                                    value={edit.notes}
                                    onChange={(e) => setEdit({ ...edit, notes: e.target.value })}
                                    placeholder="Enter notes"
                                />
                            </Col>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEditModal(false)}>Cancel</Button>
                    <Button variant="success" onClick={handleEditCourse}>Add Details</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showViewModal} onHide={() => setShowViewModal(false)} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        
                         Job Assists Details 
                           
}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectjob && 
                    <h3>Balance Amount <span style={{ color: "red" }}>{selectjob.balance_amount}</span>
                    </h3>}
                    <Tabs defaultActiveKey="general" id="student-details-tabs" className="mb-3">
                        <Tab eventKey="general" title="General">
                            {selectjob && (
                                <>
                                    <p><strong>Name:</strong> {selectjob.name}</p>
                                    <p><strong>Email Id:</strong> {selectjob.email}</p>
                                    <p><strong>Phone:</strong> {selectjob.phone}</p>
                                    <p><strong>Job Details:</strong> {selectjob.option}</p>
                                    <p><strong>Date:</strong> {selectjob.joining_date}</p>
                                    <p><strong>Process Level:</strong> {selectjob.process_level}</p>
                                    <p><strong>Notes:</strong> {selectjob.notes}</p>

                                </>
                            )}

                        </Tab>
                        <Tab eventKey="Payment" title="Payment Details">
                            {selectjob && (
                                <>
                                    <p><strong>Total Amount:</strong> {selectjob.total_amount}</p>
                                    <p><strong>Initial Amount:</strong> {selectjob.firstpayment}</p>
                                    <p><strong>1<sup>st</sup> Payment:</strong> {selectjob.secoundpayment}</p>
                                    <p><strong>2<sup>nd</sup> Payment:</strong> {selectjob.thirdpayment}</p>
                                    <p><strong>Balance Amount:</strong> {selectjob.balance_amount}</p>
                                    <p><strong>Payment status:</strong> {selectjob.paymentstatus}</p>


                                </>
                            )}

                        </Tab>

                    </Tabs>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowViewModal(false)}>OK</Button>
                </Modal.Footer>
            </Modal>





        </div>
    );
}

export default Jobassist;
